import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getCycle, deleteCycle } from './cycle.reducer';

export const CycleDeleteDialog = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId?: string; id: string }>) => {
  const { ecoleid, anneeScolaireId, id } = props.match.params;
  const dispatch = useAppDispatch();
  const fromConfig = new URLSearchParams(props.location.search || '').get('fromConfig') === '1';

  useEffect(() => {
    dispatch(getCycle(id));
  }, []);

  const cycleEntity = useAppSelector(state => state.cycle.entity);
  const updateSuccess = useAppSelector(state => state.cycle.updateSuccess);

  const handleClose = () => {
    if (fromConfig) {
      props.history.push(`/configuration-pedagogie/${ecoleid}`);
      return;
    }
    props.history.push(anneeScolaireId ? `/cycle/${ecoleid}/${anneeScolaireId}` : `/cycle/${ecoleid}`);
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    dispatch(deleteCycle({ id, ecoleId: ecoleid }));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="cycleDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="korischoolApp.cycle.delete.question">
        <Translate contentKey="korischoolApp.cycle.delete.question" interpolate={{ id: cycleEntity.nom }}>
          Are you sure you want to delete this Cycle?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-cycle" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CycleDeleteDialog;
